import { Serializable } from '@admin/core/models/serializable';
import { FeatureModel } from './feature-model';

export class RoleModel implements Serializable<RoleModel> {
  fromObject(object: any): RoleModel {
    Object.assign(this, object);

    this.features = [];

    if (
      object.features &&
      object.features.length &&
      object.features.length > 0
    ) {
      object.features.forEach((el) => {
        let t = new FeatureModel();
        t = t.fromObject(el);
        this.features.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public roleId: number;
  public isBasicRole: boolean;
  public keyName: string;
  public name: string;
  public features: FeatureModel[];
}
